import React from "react";
import PropTypes from 'prop-types'
import {InlineShareButtons} from 'sharethis-reactjs';
import { Box, Text/* , Row, Col, TextInput, FillButton */ } from 'tailwind-react-ui';

function ShareModal({showModal, setShowModal}){

    /*function copyCoupon(){
        var copyText = document.getElementById("coupon-text");
        copyText.select();
        document.execCommand("copy");
        copyText.blur();
    }*/

    return (
    <>
        { showModal ? (
        <>
            <Box 
            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <Box onClick={() => setShowModal(!showModal)} className="absolute w-full h-full" style={{ backgroundColor: 'rgba(27, 27, 27, 0.75)' }}/>
                <Box className="absolute sm:relative w-full sm:w-auto bottom-0 mx-auto">
                    {/*content*/}
                    <Box className="border-0 rounded-t-lg sm:rounded-b-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        {/*header*/}
                        <Box className="flex items-start justify-between rounded-t">
                            <Text is="p" text={'dark-light-gray'} className="quicksand-bold text-2xl mx-4 mt-4 ">
                            Compartir cupón
                            </Text>
                            <button
                                className="ml-auto bg-transparent border-0 text-black opacity-5 float-right text-5xl leading-none font-semibold outline-none focus:outline-none"
                                onClick={() => setShowModal(!showModal)}>
                                <Text is="span" text={'dark-light-gray'} className="quicksand-bold bg-transparent h-10 w-10 text-4xl block outline-none focus:outline-none">
                                ×
                                </Text>
                            </button>
                        </Box>
                        {/*body*/}
                        <Box m={{t:3, b: 4}} className="px-4 pb-6 pt-2 sm:pb-2 w-full" style={{ minWidth: '20rem' }}>
                            <InlineShareButtons
                            config={{
                                alignment: 'center',  // alignment of buttons (left, center, right)
                                color: 'social',      // set the color of buttons (social, white)
                                enabled: true,        // show/hide buttons (true, false)
                                font_size: 16,        // font size for the buttons
                                labels: 'null',        // button labels (cta, counts, null)
                                language: 'es',       // which language to use (see LANGUAGES)
                                networks: [           // which networks to include (see SHARING NETWORKS)
                                'messenger',
                                'whatsapp',
                                'email',
                                'twitter',
                                'facebook',
                                'sharethis'
                                ],
                                padding: 10,          // padding within buttons (INTEGER)
                                radius: 20,            // the corner radius on each button (INTEGER)
                                show_total: false,
                                size: 40,             // the size of each button (INTEGER)
                    
                                // OPTIONAL PARAMETERS
                                url: 'https://sixtynite.com/chelas-gratis', // (defaults to current url)
                                image: 'https://storage.googleapis.com/assets-sixtynite-com/chelas-gratis/logotipo-sixtynite.png',  // (defaults to og:image or twitter:image)
                                description: 'Obtén 2 chelas gratis presentando este cupón en tu visita a un motel de Sixtynite',       // (defaults to og:description or twitter:description)
                                title: 'Obtén 2 chelas gratis aquí:',            // (defaults to og:title or twitter:title)
                                message: 'Obtén 2 chelas gratis presentando este cupón en tu visita a un motel de Sixtynite',     // (only for email sharing)
                                subject: '2 chelas gratis',  // (only for email sharing)
                                username: 'SixtyniteApp' // (only for twitter sharing)
                            }}/>
                                <div className="st-inline-share-buttons" data-url="http://sharethis.com" data-network="twitter" data-title="Sharing is great!"></div>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
        ) : null}
    </>      
    );
}

ShareModal.propTypes = {
    showModal: PropTypes.bool,
    setShowModal: PropTypes.func
}

ShareModal.defaultProps = {
    showModal: true
}

export default ShareModal;